import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator'
@Component({
  selector: 'app-view-message',
  templateUrl: './view-message.component.html',
  styleUrls: ['./view-message.component.css']
})
export class ViewMessageComponent implements OnInit {

  message = [];
  index = '';
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _api: ApiService,
    private spinner: NgxSpinnerService) { }
  page = {
    pageSizeOptions: [1, 10, 25, 50, 100]
    , limit: 1
    , pageSize: 1
    , index: 0
  };
  PageChange($event) {
    this.page.pageSize = $event.pageSize;
    this.page.index = $event.pageIndex;
    let page: number = $event.pageIndex;
    if (this.data['filter'] === 'unread') {

      ($event.pageIndex > $event.previousPageIndex) ? (page = $event.pageIndex - 1) : page = $event.pageIndex;
    }

    this.getMessage({ page: page + 1 });
  }

  ngOnInit() {

    const paginatorIntl = this.paginator._intl;
    paginatorIntl.nextPageLabel = 'Next message';
    paginatorIntl.previousPageLabel = 'Previous message';
    paginatorIntl.firstPageLabel = 'First message';
    paginatorIntl.lastPageLabel = 'Last message';
    this.index = this.data['index'];
    this.getMessage({ page: this.index });


  }
  getMessage(Data) {
    const apiData = {
      page: Data.page
      , limit: 1
    };
    if (this.data['filter'] === 'Delpage') {
      apiData['deleted_view'] = 'Y';
    } else {
      apiData['filter'] = this.data['filter'];
    }

    this._api.functionPOST('user/getNofiticationAlertInboxForUser', apiData).subscribe((response) => {
      if (response['data']['data']) {
        this.getMessagedetail({ nt_notification_alert_id: response['data']['data'][0]['nt_notification_alert_id'] });
        this.page.limit = response['data']['total'];
        this.page.index = response['data']['page'] - 1;
      }

    });

  }
  getMessagedetail(data) {
    const apiData = {

      nt_notification_alert_id: data['nt_notification_alert_id']

    };
    this.spinner.show();
    this._api.functionPOST('user/getNotificationAlert', apiData).subscribe((response) => {
      this.spinner.hide();
      this.message = response['data'];

    });
  }

}
